import { S as SearchPriceSpecial } from './index2.js';
import { g as getRoomType } from './get-room-type.js';

/**
       * **Karisma Hotels**
       *
       * @exports bs_447
       * @category engines
       */
const factory = function factory({ window, document, thn }) {
    const roomDetailsParseData = (numAdults, numChildren) => {
        const roomsArray = Array.from(document.querySelectorAll('.khr-booking-property')).filter((room) => !room.querySelector('span[data-price="0.0"]'));
        if (thn.empty(roomsArray)) {
            return [];
        }
        const roomsInfo = roomsArray
            .map((room) => {
            const roomName = room.querySelector('.khr-booking-description h2')?.textContent?.trim();
            const roomType = getRoomType(roomName);
            const ratesInfo = Array.from(room.querySelectorAll('.khr-stack-price[data-price-cat="0"]'))
                ?.map((rate) => {
                const rateName = rate.querySelector('div>p>span')?.textContent?.trim();
                const ratePrice = thn.parseNumber(rate.querySelector('[class*="khr-booking-price"] span:not([class="hdnPriceToChange"])')?.textContent);
                const hasBreakfast = false;
                const isRefundable = !rateName?.match(/no reembolsable/i);
                if (!rateName || !ratePrice) {
                    return null;
                }
                const rateData = {
                    name: rateName,
                    total_night: ratePrice,
                    breakfast: hasBreakfast,
                    refundable: isRefundable,
                };
                return rateData;
            })
                .filter((value) => value !== null);
            if (!roomName) {
                return null;
            }
            const roomData = {
                name: roomName,
                adults: numAdults || 2,
                children: numChildren || 0,
                type: roomType,
                prices: ratesInfo,
            };
            return roomData;
        });
        return roomsInfo.filter((value) => value !== null);
    };
    return {
        isUserLogged() {
            const isLogged = !document.querySelector('[data-target="#khr-modal_login"]');
            return isLogged;
        },
        onStateChange() {
            if (!window.location.hostname.includes('reservations')) {
                thn.debounce(thn.pageCheck, 600)();
            }
        },
        generateSearchUrl(ctx) {
            // Example: https://reservations.karismahotels.com/booking/hotels?tbCheckInHotelReq=2024-03-20&tbCheckOutHotelReq=2024-03-21&txtHotelPref=DO-PUJNPC&searchMask=AAC7&airfromcity=&theme=KARISMA-ES&productCode=ALL-KAR&searchType=property&brandFilter=&destinationFilter=&stackCode=ST-DWT-LTDOFFERS&stackTier=&couponCode=&brandlock=
            const url = new URL(ctx.baseUrl);
            const validUrl = url.hostname.includes('reservations.karismahotels');
            if (!validUrl) {
                ctx.newUrl = '';
                return ctx;
            }
            ctx.newUrl = url.toString();
            return ctx;
        },
        priceObserveDom(ctx) {
            // Filter applied
            const container = document.querySelector('#roomListContainer .container.d-none');
            if (container) {
                const refreshPrice = thn.debounce(() => { ctx.widget.refresh(); }, 1200);
                thn.observeDom(container, refreshPrice, {
                    attributes: true,
                    subtree: true,
                    childList: true,
                    characterData: true,
                });
                thn.pageUnload(() => {
                    refreshPrice.cancel();
                    thn.stopObserveDom(container, refreshPrice);
                });
            }
            // currency change
            const priceEl = document.querySelector('[id*="roomPricingContainer"] [class*="khr-stack-price"][data-price-cat="0"] [class*="khr-booking-price"] span:not([style="filter:blur(4px)"]):not([class="hdnPriceToChange"])');
            if (priceEl) {
                const refreshPrice = thn.debounce(() => { ctx.widget.refresh(); }, 1200);
                thn.observeDom(priceEl, refreshPrice, {
                    characterData: true,
                });
                thn.pageUnload(() => {
                    refreshPrice.cancel();
                    thn.stopObserveDom(priceEl, refreshPrice);
                });
            }
        },
        priceParseData(ctx) {
            // Guests, Adults & Children
            const roomsDispo = [];
            const adults = thn.parseNumber(document.querySelector('[id*="intRoom"][id*="Adults"]')?.value) ?? 2;
            const children = thn.parseNumber(document.querySelector('[id*="intRoom"][id*="Children"]')?.value) ?? 0;
            const childrenAgesEl = Array.from(document.querySelectorAll('.childAge:not(.d-none) [id*="intRoom"][id*="ChildAge"]'));
            const childrenAges = childrenAgesEl?.map((el) => thn.parseNumber(el.value)).filter((value) => value !== undefined) ?? [];
            const roomData = {
                adults,
                children,
                children_ages: childrenAges,
            };
            roomsDispo.push(roomData);
            // Dates
            const dates = document.querySelector('#DatePicker')?.value?.split('-') ?? [];
            const dateBegin = dates[0].trim()?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2') || thn.parseUrlParameter('tbCheckInHotelReq')?.replace(/-/g, '/');
            const dateEnd = dates[1].trim()?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2') || thn.parseUrlParameter('tbCheckOutHotelReq')?.replace(/-/g, '/');
            if (!dateBegin || !dateEnd) {
                return null;
            }
            // Prices & Currency || No Rooms
            const pricesEls = Array.from(document.querySelectorAll('[id*="roomPricingContainer"] [class*="khr-stack-price"]:not(.d-none) [class*="khr-booking-price"] span:not([style="filter:blur(4px)"]):not([class="hdnPriceToChange"])'));
            const prices = pricesEls
                .map((price) => thn.parseNumber(price.textContent))
                .filter((value) => typeof value !== 'undefined');
            const currency = thn.parseCurrency(pricesEls?.[0]?.textContent);
            const noAvailability = thn.empty(pricesEls);
            const filterApplied = !document.querySelector('.active[data-khr-price-tab="#price-tab-0"]');
            const priceSpecial = filterApplied
                ? SearchPriceSpecial.Generic
                : SearchPriceSpecial.None;
            if (!thn.empty(prices) && currency) {
                return {
                    adults,
                    children,
                    rooms_dispo: roomsDispo,
                    date_begin: dateBegin,
                    date_end: dateEnd,
                    price: Math.min(...prices),
                    currency,
                    price_special: priceSpecial,
                    room_details: roomDetailsParseData(adults, children),
                };
            }
            if (noAvailability) {
                return {
                    adults,
                    children,
                    currency,
                    date_begin: dateBegin,
                    date_end: dateEnd,
                    no_rooms: true,
                };
            }
            return null;
        },
        bookingParseData(ctx) {
            // multiple rooms case
            const multiRoomsEl = document.querySelectorAll('[data-ddc-parent="room"]');
            const isMultiroom = multiRoomsEl.length > 1;
            if (isMultiroom) {
                const data = Array.from(multiRoomsEl).map((room) => {
                    // Booking ID
                    const bookingId = room.querySelector('.col-12.col-sm-9')?.textContent?.trim();
                    if (!bookingId) {
                        return {
                            set: false,
                        };
                    }
                    // Dates
                    const dateBegin = thn.objectGet(window.dataLayer, 'arrivalDate', { first: false })?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
                    const dateEnd = thn.objectGet(window.dataLayer, 'departureDate', { first: false })?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
                    // Adult & Children
                    const adults = thn.parseNumber(room.querySelector('[data-ddc-name="adults"]')?.textContent);
                    const children = thn.parseNumber(room.querySelector('[data-ddc-name="children"]')?.textContent);
                    // Price & Currency
                    const price = thn.parseNumber(room.querySelector('[data-ddc-name="room price"]')?.textContent);
                    const currency = thn.parseCurrency(document.querySelector('[data-ddc-name="currency"]')?.textContent);
                    return {
                        booking_id: bookingId,
                        date_begin: dateBegin,
                        date_end: dateEnd,
                        adults,
                        children,
                        price,
                        currency,
                    };
                });
                return data;
            }
            // HTML data
            const domData = document.querySelector('.gtm-purchase');
            // Booking ID
            const bookingId = thn.objectGet(window.dataLayer, 'transactionId', { first: false }) || domData?.getAttribute('data-transaction-id');
            if (!bookingId) {
                return {
                    set: false,
                };
            }
            // Dates
            const dateBegin = thn.objectGet(window.dataLayer, 'reservation_startdate', { first: false })?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2');
            const dateEnd = thn.objectGet(window.dataLayer, 'reservation_enddate', { first: false })?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2');
            // Adult & Children
            const adults = thn.parseNumber(domData?.getAttribute('data-guests-adults')) ?? 2;
            const children = thn.parseNumber(domData?.getAttribute('data-guests-child')) ?? 0;
            // Price & Currency
            const price = thn.parseNumber(thn.objectGet(window.dataLayer, 'value', { first: false }) || domData?.getAttribute('data-price'));
            const currency = thn.parseCurrency(thn.objectGet(window.dataLayer, 'currency', { first: false }) || domData?.getAttribute('data-price'));
            return {
                booking_id: bookingId,
                date_begin: dateBegin,
                date_end: dateEnd,
                adults,
                children,
                price,
                currency,
            };
        },
    };
};

export { factory };
